import { Payments } from '../Payments';
import { Divider } from '../../../components/Divider';
import { Cart as CartModule } from '../../../Cart/Cart';
import { Items as CartItems } from '../../../Cart/components/Items';
import { Row } from '../../../Cart/components/Row';

import { castOrderItem } from '../../utils/castOrderItem';
import { getRefundPayments } from '../../utils/getRefundPayments';

import { Flex } from '../../../GlobalComponents/Flex';
import styled from 'styled-components';
import { centsToMoney } from '../../../utils/centsToMoney';

import { OrderFieldsFragment } from '../../graphql';

export type RefundItemsProps = React.HTMLAttributes<HTMLDivElement> &
	React.HTMLAttributes<HTMLDivElement> &
	Pick<OrderFieldsFragment, 'refunds'>;

export const RefundItems: React.FC<RefundItemsProps> = ({ refunds }) => {
	return (
		<div className="refund-items">
			<br />
			<h3 className="mb-0 text-primary">
				Order refund{refunds.length > 1 ? 's' : ''}
			</h3>

			<Divider my={3} />

			{refunds.map((refund, key) => {
				const [giftCardPayments, creditCardPayments] =
					getRefundPayments(refund);

				const payments = [
					...giftCardPayments.map(payment => (
						<Flex key={payment.id} $justifyContent="space-between">
							<Title>BIGGBY Card #{payment.cardNumber}</Title>
							<Amount>${centsToMoney(payment.amount)}</Amount>
						</Flex>
					)),
					...creditCardPayments.map(payment => (
						<Flex key={payment.id} $justifyContent="space-between">
							<Title>Credit Card: {payment.identifier}</Title>
							<Amount>${centsToMoney(payment.amount)}</Amount>
						</Flex>
					))
				];

				return (
					<div key={key}>
						{refunds.length > 1 ? (
							<>
								<h4 className="text-secondary mb-0">
									Refund #{key + 1}
								</h4>
								<br />
							</>
						) : null}

						<CartModule>
							<div className="cart-header">
								<Row left="Refunded Item" right="Price" />
							</div>

							<Divider />

							<CartItems
								items={refund.items.map(castOrderItem)}
								checkIsItemEditable={() => false}
								divider={<Divider my={2} borderColor="light" />}
							/>
						</CartModule>

						<Payments payments={payments} isRefund={true} />
					</div>
				);
			})}
		</div>
	);
};

const Title = styled.div`
	font-weight: 500;
	font-size: 20px;
	color: #222222;
`;

const Amount = styled.div`
	font-weight: 500;
	font-size: 20px;
	color: #575757;
`;
